export default __webpack_public_path__ + "static/gelato-abc6d6583fdda945f79693a32fb11e54.png";